module.exports = __webpack_public_path__ + "img/mobileHome.8bd90b2c.svg";